export default __webpack_public_path__ + "static/media/lock.ca5f9383.svg";